module.exports = __webpack_public_path__ + "static/img/13.7a687375.png";